<template>
    <div class="printOrderDetails">
        <!-- 订单状态 -->
        <div class="detailsState">
            <div class="detailsState_one">
                <i
                    class="el-icon-arrow-left"
                    @click="$router.go(-1)"
                ></i>
                <p class="detailsState_one_title">订单状态</p>
                <span v-if="processActive==='UN_CONFIRM'">您已下单，待商家确认</span>
                <span v-if="processActive==='UN_PAY'">商家已确认，待付款</span>
                <span v-if="processActive==='OFFLINE_UN_CONFIRM'">线下支付待确认</span>
                <span v-if="processActive==='DELIVERY_ON_CASH_UN_CONFIRM'">货到付款待确认</span>
                <span v-if="processActive==='UN_EFFECT'">商家已确认，待付款</span>
                <span v-if="processActive==='UN_APPRAISE'">交易已完成</span>
                <span v-if="processActive==='UN_CANCEL'">交易关闭</span>
            </div>
            <div class="detailsState_one">
                <p v-if="processActive==='UN_CONFIRM'">
                    商家在{{day}}天{{hr}}小时{{min}}分{{sec}}秒内未确认，则系统将自动取消订单
                </p>
                <p v-if="processActive==='UN_PAY'">
                    请在{{day}}天{{hr}}小时{{min}}分{{sec}}秒内付款，若未及时付款，系统将自动取消订单
                </p>
                <p v-if="processActive==='OFFLINE_UN_CONFIRM'">
                    您可以通过消息联系商家确认支付结果
                </p>
                <p v-if="processActive==='DELIVERY_ON_CASH_UN_CONFIRM'">
                    您可以通过消息联系商家确认支付方式
                </p>
                <p v-if="processActive==='UN_EFFECT'">
                    您可以通过消息联系商家，进行实施
                </p>
                <p v-if="processActive==='UN_APPRAISE'">
                    交易已完成，请给商家评价
                </p>
                <p v-if="processActive==='UN_CANCEL'">
                    买家取消订单，原因:{{ cancelReason }}
                </p>
            </div>
        </div>
        <!-- 报价流程 -->
        <div class="details">
            <div class="detailsProcess">
                <div class="processItem" v-if="processActive!=='UN_CANCEL' && orderBase.payType == 'OFFLINE_PAY' && orderBase.payChannel == 'TRANSFER'" v-for="(item,index) in processList1" :key="index">
                    <div :class="processActive === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
                <div class="processItem" v-if="processActive!=='UN_CANCEL' && orderBase.payType == 'DELIVERY_ON_CASH' && orderBase.payChannel == 'DELIVERY_ON_CASH'" v-for="(item,index) in processList2" :key="index">
                    <div :class="processActive === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
                <div class="processItem" v-if="processActive!=='UN_CANCEL' && orderBase.payType !== 'OFFLINE_PAY' && orderBase.payChannel !== 'TRANSFER' && orderBase.payType !== 'DELIVERY_ON_CASH' && orderBase.payChannel !== 'DELIVERY_ON_CASH'" v-for="(item,index) in processList" :key="index">
                    <div :class="processActive === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
            </div>
            <!--订单信息-->
            <div class="orderInformation">
                <div class="orderTop">
                    <h3>订单信息</h3>
                    <div class="orderItem"  style="display:flex;width:1000px" >
                        <div class="name" style="min-width:60px">服务商：</div>
                        <div class="content" style="display:flex;"><span style="min-width:168px;">{{ serviceInfo.enterPriseName }} </span><i class="iconfont icon-weixin" @click="startChat(serviceInfo.enterPriseId)"></i></div>
                    </div>
                </div>
                <div class="orderBottom">
                    <div class="orderItem" style="align-items:center">
                        <div class="name">订单编号：</div>
                        <div class="content">{{ orderBase.orderNo }}</div>
                    </div>
                    <div class="orderItem"  style="align-items:center">
                        <div class="name">创建时间：</div>
                        <div class="content">{{ orderBase.createDate }}</div>
                    </div>
                    <div class="orderItem" v-if="orderBase.payChannel!=null && orderBase.payType!=null">
                        <div class="name">付款时间：</div>
                        <div class="content">{{ orderBase.payDate }}</div>
                    </div>
                    <div class="orderItem" v-if="orderBase.payChannel!=null && orderBase.payType!=null">
                        <div class="name">付款渠道：</div>
                        <div class="content">
                            {{ orderBase.payChannelCn }}
                        </div>
                    </div>
                </div>
                <!--<div class="orderBottom" style="padding-top: 20px;">
                    <div class="orderItem" style="width: 100%;">
                        <div class="name">备注：</div>
                        <div class="content"></div>
                    </div>
                </div>-->
            </div>
            <!--发票信息-->
            <div class="basicInformation">
                <div class="invoiceInformation" v-if="issueInvoice">
                    <h3>发票信息</h3>
                    <div class="goodsItem">
                        <div class="name">发票要求：</div>
                        <div class="content">{{ issueInvoice.issueType=='ZZFP'?'纸质发票':'电子发票' }}</div>
                    </div>
                    <div class="goodsItem">
                        <div class="name">发票类型：</div>
                        <div class="content">{{ invoiceInfo.invoiceType=='NORMAL'?'增值税普通发票':'增值税专用发票' }}</div>
                    </div>
                    <div class="goodsItem" v-if="invoiceInfo.invoiceType=='SPECIAL'">
                        <div class="name">开票信息：</div>
                        <div class="content">{{ invoiceInfo.title }}
                            <el-popover
                                placement="right"
                                width="400"
                                trigger="click">
                                <div class="billingInformation ">
                                    <div class="title">开票信息</div>
                                    <div class="billingContent">
                                        <div class="billingItem">
                                            <div class="name">开票抬头：</div>
                                            <div class="content">{{ invoiceInfo.title }}</div>
                                        </div>
                                        <div class="billingItem">
                                            <div class="name">纳税人识别号：</div>
                                            <div class="content">{{ invoiceInfo.code }}</div>
                                        </div>
                                        <div class="billingItem">
                                            <div class="name">地址：</div>
                                            <div class="content">{{ invoiceInfo.address }}</div>
                                        </div>
                                        <div class="billingItem">
                                            <div class="name">电话：</div>
                                            <div class="content">{{ invoiceInfo.mobile }}</div>
                                        </div>
                                        <div class="billingItem">
                                            <div class="name">开户行：</div>
                                            <div class="content">{{ invoiceInfo.bank }}</div>
                                        </div>
                                        <div class="billingItem">
                                            <div class="name">账号：</div>
                                            <div class="content">{{ invoiceInfo.bankAccount }}</div>
                                        </div>
                                    </div>
                                </div>
                                <el-button type="text"  slot="reference" style="padding: 0 0 0 10px;">详细</el-button>
                            </el-popover>
                        </div>
                    </div>
                    <!--邮寄地址和电子邮箱根据发票类型显示其中一个-->
                    <div class="goodsItem" v-if="issueInvoice.issueType=='ZZFP'">
                        <div class="name">发票邮寄地址：</div>
                        <div class="content">{{ payeeInfo.province }}{{ payeeInfo.city }}{{ payeeInfo.district }}{{ payeeInfo.areaInfo }}</div>
                    </div>
                    <div class="goodsItem" v-else>
                        <div class="name">电子邮箱：</div>
                        <div class="content">{{ invoiceInfo.payeeEmail }}</div>
                    </div>
                </div>
                <div v-else>
                    <h3>发票信息</h3>
                    <div class="goodsItem">
                        <div class="name">暂未开具发票</div>
                    </div>
                </div>
            </div>
            <!--服务信息-->
            <div class="printInformation">
                <h3>服务信息</h3>
                <div class="printTableContent">
                    <div class="tableHeader">
                        <div class="name">打印服务</div>
                        <div class="price">单价</div>
                        <div class="price">实付款</div>
                    </div>
                    <div class="tableBody">
                        <div class="name">
                            <div class="orderInfo">
                                <img :src="serviceInfo.serviceImg" alt="">
                                <div class="infoContent">
                                    <div class="infoName" :title="serviceInfo.serviceName">{{ serviceInfo.serviceName }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="price">
                            <div>
                                ¥ {{ serviceInfo.servicePrice }}
                            </div>
                        </div>
                        <div class="price">
                            <div>
                                ¥ {{ serviceInfo.totalPrice }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--功能按钮-->
            <div class="functionButton" v-if="type !== 'evaluate'">
                <div class="functionButton">
                    <el-button type="primary" v-show="processActive === 'UN_PAY'" @click="submitPay">付款</el-button>
                    <el-button type="primary" v-show="processActive === 'UN_CONFIRM' || processActive === 'UN_PAY'|| processActive == 'OFFLINE_UN_CONFIRM' || processActive == 'DELIVERY_ON_CASH_UN_CONFIRM'" @click="cancelOrder(serviceInfo)">取消订单</el-button>
                    <el-button type="primary" v-show="processActive === 'UN_APPRAISE'" @click="toEvaluate">评价</el-button>
                    <el-button type="primary" v-show="processActive === 'UN_EXAMINE'" @click="finishOrder(serviceInfo)">确认完成</el-button>
                    <el-button type="primary" v-show="
                    processActive !== 'UN_CONFIRM'
                    && processActive !== 'UN_PAY'
                    && processActive !== 'OFFLINE_UN_CONFIRM'
                    && processActive !== 'DELIVERY_ON_CASH_UN_CONFIRM'
                    && (orderBase.afterSaleUuid===null || (orderBase.afterSaleUuid!==null&&orderBase.afterSaleAuditStatus==='REJECT'))
                    && orderBase.splitStatus === 'NONE'"
                               @click="AfterSales(orderBase.uuid,enterPriseId,enterPriseName,processActive,serviceInfo.totalPrice)">
                        申请售后
                    </el-button>
                    <el-button type="primary" v-show="processActive !== 'UN_CONFIRM'
                    && processActive !== 'UN_PAY' &&
                    processActive !== 'UN_CANCEL'
                    && processActive !== 'AFTER_SALES'
                    && processActive !== 'DELIVERY_ON_CASH_UN_CONFIRM'
                    && orderBase.afterSaleAuditStatus !== 'PASS'
                    && this.issueInvoice === null" @click="openInvoice">申请开票</el-button>
                    <el-button type="primary"
                               v-if="processActive === 'OFFLINE_UN_CONFIRM'
                               || processActive === 'UN_EXAMINE'
                               || processActive === 'UN_EFFECT'
                               || processActive === 'UN_APPRAISE'
                               || processActive === 'AFTER_SALES'
                               || processActive === 'FINISHED'"
                               @click="complain(orderBase.uuid,enterPriseId,enterPriseName)">
                        投诉</el-button>
                </div>
            </div>
        </div>

        <!-- 取消订单 -->
        <el-dialog
            title="取消订单"
            :visible.sync="cancelDialogVisible"
            :close-on-click-modal="false"
            width="1000px">
            <div class="logisticsDialog">
                <el-form ref="logisticsForm" :rules="cancelRules" class="demo-ruleForm">
                    <el-form-item class="addressList">
                        <el-select v-model="cancelUuid" placeholder="取消原因">
                            <el-option v-for="(item,index) in cancelList" :key="index"
                                       :label="item.name"
                                       :value="item.uuid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="submitButtonGroup">
                        <el-button type="primary" @click="cancelSubmit">确定</el-button>
                        <el-button @click="cancelDialogVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

        <!--评价弹出框-->
        <el-dialog title="评价" :visible.sync="evaluateDialogVisible" width="500px">
            <div class="evaluateDialogBox">
                <div class="evaluateItem">
                    <div class="name">评价等级</div>
                    <div class="content">
                        <div class="rateItem">
                            <div class="name">描述相符</div>
                            <el-rate
                                v-model="evaluateForm.descriptionPoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">服务态度</div>
                            <el-rate
                                v-model="evaluateForm.servicePoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">专业程度</div>
                            <el-rate
                                v-model="evaluateForm.transportPoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价标签</div>
                    <div class="content">
                        <el-checkbox-group
                            v-model="evaluateForm.evaluationTagList"
                            class="evaluateTag"
                        >
                            <el-checkbox-button
                                v-for="tag in tagList"
                                :label="tag"
                                :key="tag.tagUuid"
                            >{{ tag.tagName }}</el-checkbox-button
                            >
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价内容</div>
                    <div class="content">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 6 }"
                            placeholder="请输入内容"
                            v-model="evaluateForm.evaluationContent"
                        >
                        </el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
            <el-button @click="evaluateDialogVisible = false">取 消</el-button>
            <el-button type="primary" :disabled="stepLoading" @click="evaluateSubmit">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 申请开票 -->
        <issue-invoice-dialog ref="invoiceDialogRef"></issue-invoice-dialog>

        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>

        <!-- 购买的弹窗 -->
        <PayModelDialog ref="payModelRef" @refreshData="getServiceDetail"/>

        <!-- 申请售后 -->
        <after-sales-dialog
            ref="afterSalesDialog"
        ></after-sales-dialog>

        <!-- 付款方式 -->
        <TermsOfPayment ref="termsOfPaymentRef" @offlinePay="offlinePayOrder"/>
        <!-- 投诉弹窗 -->
        <complaints-dialog
            ref="dialogRef"
        ></complaints-dialog>
    </div>
</template>

<script>
    import { getAddressDetail,findInvoiceInfo,updateOrderBaseInfo,
        updateOrderServiceInfo, getDictionaryItemDetail,
        getDictionaryItem,getServiceOrderDetail, getRongCloudUser, saveEvaluation, offlinePay, deliveryOnCash, } from '../../../utils/interface';

    import {getIssueInvoiceByOrderId} from  '../../../utils/issueInvoice';
    import issueInvoiceDialog from "./issueInvoiceDialog";

import chatDialog from "../../../components/chat/chatDialog";
import afterSalesDialog from "./afterSalesDialog";
import PayModelDialog from "./payModelDialog";
    import TermsOfPayment from '../../../components/termsOfPayment/termsOfPayment'
    import complaintsDialog from './complaintsDialog'
    export default {
        name: "printOrderDetails",
        data() {
            return {
                stepLoading: false,
                processActive: '',
                invoiceStatus: '',
                processList: [
                    {
                        id: 'UN_CONFIRM',
                        name: '卖家确认'
                    },
                    {
                        id: 'UN_PAY',
                        name: '订单支付'
                    },
                    {
                        id: 'UN_EFFECT',
                        name: '卖家线下实施'
                    },
                    {
                        id: 'UN_APPRAISE',
                        name: '评价'
                    },
                    {
                        id: 'FINISHED',
                        name: '完成'
                    },
                ],
                processList1: [
                    {
                        id: 'UN_CONFIRM',
                        name: '卖家确认'
                    },
                    {
                        id: 'UN_PAY',
                        name: '订单支付'
                    },
                    {
                        id: "OFFLINE_UN_CONFIRM",
                        name: "线下支付待确认",
                    },
                    {
                        id: 'UN_EFFECT',
                        name: '卖家线下实施'
                    },
                    {
                        id: 'UN_APPRAISE',
                        name: '评价'
                    },
                    {
                        id: 'FINISHED',
                        name: '完成'
                    },
                ],
                processList2: [
                    {
                        id: 'UN_CONFIRM',
                        name: '卖家确认'
                    },
                    {
                        id: 'UN_PAY',
                        name: '订单支付'
                    },
                    {
                        id: "DELIVERY_ON_CASH_UN_CONFIRM",
                        name: "货到付款待确认",
                    },
                    {
                        id: 'UN_EFFECT',
                        name: '卖家线下实施'
                    },
                    {
                        id: 'UN_APPRAISE',
                        name: '评价'
                    },
                    {
                        id: 'FINISHED',
                        name: '完成'
                    },
                ],
                day: 0,
                hr: 0,
                min: 0,
                sec: 0,
                uuid:"",
                orderBase:"",
                serviceInfo:"",
                payeeInfo:"",
                invoiceInfo:"",
                type: '',
                // 取消
                cancelDialogVisible: false,
                cancelList: [],
                cancelUuid: "",
                orderBaseUuid: "",
                cancelRules: {
                    cancelUuid: [
                        {required: true, message: '请选择取消原因', trigger: 'change'}
                    ]
                },
                // 评价
                evaluateDialogVisible: false,
                evaluateForm: {
                    descriptionPoint: 0,
                    servicePoint: 0,
                    transportPoint: 0,
                    evaluationTagList: [],
                    evaluationContent: "",
                },
                tagList: [],
                issueInvoice:'', //开票信息
                // 申请开票
                invoiceDialogVisible:false,
                dialogVisibleDialog: false,
                // 取消原因
                cancelReason: "",
            }
        },
        created(){
            this.uuid = this.$route.params.uuid;
            this.type = this.$route.params.type;
            this.getServiceDetail();
            this.getDictionaryItem();
        },
        mounted() {
            this.countdown()
        },
        components: {
            issueInvoiceDialog,
            chatDialog,
            afterSalesDialog,
            PayModelDialog,
            TermsOfPayment,
            complaintsDialog,
        },
        methods: {
            //投诉
            complain(orderBaseUuid, targetUserUuid, enterPriseName) {
                this.$refs.dialogRef.init(orderBaseUuid, targetUserUuid, enterPriseName);
            },
            // 获取字典值
            getDictionaryItem() {
                getDictionaryItem({groupCode: "service_evaluation_tag"}).then((res) => {
                    this.tagList = [];
                    res.forEach((item, index) => {
                        this.tagList.push({tagName: item.name, tagUuid: item.code, tagGroupId: item.groupUuid});
                    });
                });
            },
            // 点击打开评价弹出框
            toEvaluate() {
                this.order = this.serviceInfo;
                this.evaluateForm = {
                    descriptionPoint: 0,
                    servicePoint: 0,
                    transportPoint: 0,
                    evaluationTagList: [],
                    evaluationContent: "",
                };
                this.evaluateDialogVisible = true;
            },
            // 评价提交
            evaluateSubmit() {
                this.stepLoading = true;
                if (
                    this.evaluateForm.descriptionPoint &&
                    this.evaluateForm.servicePoint &&
                    this.evaluateForm.transportPoint
                ) {
                    this.evaluateForm.orderNo = this.order.orderBase.orderNo;
                    this.evaluateForm.orderUuid = this.order.uuid;
                    this.evaluateForm.orderType = 'SERVICE';
                    this.evaluateForm.evaluationType = 'NORMAL';
                    this.evaluateForm.sellerName = this.order.enterPriseName;
                    this.evaluateForm.sellerUuid = this.order.enterPriseId;
                    this.evaluateForm.orderName = this.order.serviceName;
                    this.evaluateForm.orderAmount = this.order.orderBase.totalPrice;

                    saveEvaluation(this.evaluateForm).then((response) => {
                        if (response.success) {
                            this.evaluateDialogVisible = false;
                            this.getServiceDetail();
                            this.$message({
                                type: "success",
                                message: "评价成功",
                            });
                        } else {
                            this.$message({
                                type: "error",
                                message: response.message,
                            });
                        }
                    });
                } else {
                    this.$message.warning("请选择评价等级");
                }
                setTimeout(() => {
                    this.stepLoading = false;
                }, 1000);
            },
            finishOrder(item){
                this.$confirm('确认完成订单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 未支付
                    this.orderBase.orderStatus = "UN_APPRAISE";
                    updateOrderBaseInfo(this.orderBase).then((res)=>{
                        if(res.success){
                            updateOrderServiceInfo({uuid:item.uuid,serviceStatus:"UN_APPRAISE"}).then((res)=>{
                                if(res.success){
                                    this.$message.success('订单已完成！');
                                    this.getServiceDetail();
                                }
                            });
                        }
                    });
                });
            },
            // 取消
            cancelOrder(item){
                getDictionaryItem({groupCode:"service_cancel_reason"}).then((res)=>{
                    this.cancelList = res;
                    this.uuid = item.uuid;
                    this.orderBaseUuid = this.orderBase.uuid;
                    this.cancelDialogVisible = true;
                });
            },
            // 取消确定
            cancelSubmit(){
                if(this.cancelUuid==""){
                    this.$message.error('请选择取消原因！');
                    return false;
                }
                updateOrderBaseInfo({uuid:this.orderBase.uuid,orderStatus:"UN_CANCEL",cancelOrderUuid:this.cancelUuid}).then((res)=>{
                    if(res.success){
                        updateOrderServiceInfo({uuid:this.uuid,serviceStatus:"UN_CANCEL"}).then((result)=>{
                            if(result.success){
                                this.$message.success('订单取消成功！');
                                this.cancelDialogVisible = false;
                                this.getServiceDetail();
                            }
                        });
                    }
                });
            },
            // 支付
            submitPay(item){
                // 付款的选择弹窗
                this.$refs.termsOfPaymentRef.init()
                /*updateOrderBaseInfo({uuid:this.orderBase.uuid,orderStatus:"UN_SEND"}).then((res)=>{
                    if(res.success){
                        updateOrderServiceInfo({uuid:item.uuid,serviceStatus:"UN_EFFECT"}).then((res)=>{
                            if(res.success){
                                this.$message.success('订单支付成功！');
                                this.getServiceDetail();
                            }
                        });
                    }
                });*/
            },
            //线下支付上传凭证
            offlinePayOrder(obj){
                if(obj.radio == 1){
                    this.$refs.payModelRef.init();
                    window.open(this.$url.payUrl + this.orderBase.orderNo, "_blank");
                } else if(obj.radio == 2 && obj.imageUrl != '' && obj.imageUrl != null){
                    let form ={orderNo: this.orderBase.orderNo, orderBaseUuid: this.orderBase.uuid, payTicket: obj.imageUrl};
                    offlinePay(form).then(res=> {
                        console.log(res);
                        if (res && res.success) {
                            this.$message.success(res.message);
                            this.getServiceDetail();
                        }else {
                            this.$message.error(res.message);
                        }
                    });
                } else if(obj.radio == 3){
                    let form ={orderNo: this.orderBase.orderNo, orderBaseUuid: this.orderBase.uuid};
                    deliveryOnCash(form).then(res=> {
                        console.log(res);
                        if (res && res.success) {
                            this.$message.success(res.message);
                            this.getServiceDetail();
                        }else {
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            getServiceDetail(){
                let params = {
                    uuid:this.uuid
                };
                getServiceOrderDetail(params).then((res)=>{
                    if(res) {
                        this.serviceInfo = res;
                        this.orderBase = res.orderBase;
                        this.processActive = res.orderBase.orderStatus;
                        this.invoiceStatus = res.invoiceStatus;
/*                        // 发票地址
                        if(res.payeeUuid!="") {
                            getAddressDetail({uuid: res.payeeUuid}).then((res) => {
                                this.payeeInfo = res;
                            });
                        }
                        // 收票地址信息
                        if(res.invoiceUuid!="") {
                            findInvoiceInfo({uuid:res.invoiceUuid}).then((res)=>{
                                this.invoiceInfo = res;
                            });
                        }*/
                        // 倒计时
                        if(this.orderBase.orderTimeType!=null&&this.orderBase.timeValue){
                            this.getDay(this.orderBase.orderTimeType);
                        }
                        // 取消原因
                        if(this.orderBase.cancelOrderUuid!=null){
                            getDictionaryItemDetail(this.orderBase.cancelOrderUuid).then((res)=>{
                                if(res){
                                    this.cancelReason = res.name;
                                }
                            });
                        }
                        //开票信息
                        getIssueInvoiceByOrderId(res.orderBaseUuid).then((res)=>{
                            this.issueInvoice = res.data;
                            console.log("issueInvoice="+JSON.stringify(res.data));
                            if(res.success){
                                if(this.issueInvoice.payeeUuid!=null){
                                    getAddressDetail({uuid:this.issueInvoice.payeeUuid}).then((res)=>{
                                        console.log("1="+JSON.stringify(res))
                                        this.payeeInfo = res;
                                    });
                                }
                                // 收票地址信息
                                if(this.issueInvoice.invoiceUuid!= null){
                                    findInvoiceInfo({uuid:this.issueInvoice.invoiceUuid}).then((res)=>{
                                        console.log("2="+JSON.stringify(res))
                                        this.invoiceInfo = res;
                                    });
                                }
                            }
                        });
                    }
                });
            },
            getDay(timeType){
                if(timeType==='HOUR'){
                    let editDate = new Date(this.orderBase.editDate);
                    let countdownTime = editDate.getTime() + 1000 * 60 * 60 * Number(this.orderBase.timeValue);
                    editDate.setTime(countdownTime);
                    let tYear = editDate.getFullYear();
                    let tMonth = editDate.getMonth();
                    let tDate = editDate.getDate();
                    let getHours = editDate.getHours();
                    let getMinutes = editDate.getMinutes();
                    let getSeconds = editDate.getSeconds();
                    tMonth = this.doHandleMonth(tMonth + 1);
                    tDate = this.doHandleMonth(tDate);
                    let date = tYear + '-' + tMonth + '-' + tDate + ' ' + getHours + ':' + getMinutes + ':' + getSeconds;
                    this.countdown(date);
                }
            },
            doHandleMonth (month) {
                let m = month;
                if (month.toString().length === 1) {
                    m = '0' + month
                }
                return m
            },
            // 倒计时
            countdown(date) {
                // 定义结束时间戳
                let end = new Date(date);
                // 定义当前时间戳
                let now = new Date();
                // 做判断当倒计时结束时都为0
                if (now >= end) {
                    this.day = 0;
                    this.hr = 0;
                    this.min = 0;
                    this.sec = 0;
                    return
                }
                // 用结束时间减去当前时间获得倒计时时间戳
                let msec = end - now;
                //算出天数
                let day = parseInt(msec / 1000 / 60 / 60 / 24);
                //算出小时数
                let hr = parseInt(msec / 1000 / 60 / 60 % 24);
                //算出分钟数
                let min = parseInt(msec / 1000 / 60 % 60);
                //算出秒数
                let sec = parseInt(msec / 1000 % 60);
                //给数据赋值
                this.day = day;
                this.hr = hr > 9 ? hr : '0' + hr;
                this.min = min > 9 ? min : '0' + min;
                this.sec = sec > 9 ? sec : '0' + sec;
                setTimeout(()=> {
                    //this.countdown(date);
                    this.getDay(this.orderBase.orderTimeType);
                }, 1000)
            },
            // 申请开票
            searchInfo(){
                this.getServiceDetail();
            },
            openInvoice(){

                let params = {uuid:this.issueInvoice==null?"":this.issueInvoice.uuid,
                    orderUuid:this.orderBase.uuid,//订单主键
                    orderNo:this.orderBase.orderNo,//点单编号
                    orderName:this.serviceInfo.serviceName,//订单名称
                    orderImg:this.serviceInfo.serviceImg,//图片
                    orderType:'SERVICE',//类型
                    issueUser:this.serviceInfo.userUuid,//开票人、企业
                    invoiceMoney:this.serviceInfo.totalPrice,//开票金额
                }
                this.$refs.invoiceDialogRef.init(params);
            },
            startChat(targetUuid) {
                let user = this.$store.state.userMessages;
                getRongCloudUser(targetUuid).then(res=> {
                    console.log(res);
                    this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
                });
            },
            // 申请售后
            AfterSales(orderBaseUuid, targetUserUuid, enterPriseName, orderStatus, orderPrice){
                this.$refs.afterSalesDialog.init(orderBaseUuid, targetUserUuid, enterPriseName, 'SERVICE', orderStatus, orderPrice)
            }
        },
    }
</script>

<style scoped lang="less">
    p {
        margin: 0;
    }
    i {
        font-style: normal;
    }
    .printOrderDetails {
        background: #f5f5f5;
        // 订单状态
        .detailsState {
            background: #fff;
            font-size: 14px;
            padding: 26px 32px;
            margin-bottom: 8px;
            .detailsState_one {
                display: flex;
                align-items: center;
                position: relative;
                &:nth-of-type(1) {
                    margin-bottom: 16px;
                }
                i {
                    font-size: 18px;
                    margin-right: 5px;
                    cursor: pointer;
                    position: absolute;
                    left: -24px;
                }
                span{
                    color: rgba(0,0,0,.5);
                }
                .detailsState_one_title {
                    font-size: 16px;
                    font-weight: 700;
                    margin-right: 8px;
                }
                .detailsState_one_time {
                    color: #1890ff;
                }
            }
        }
        // 报价流程
        .details {
            background: #fff;
            padding: 0 8px 150px;
            .detailsProcess {
                border-bottom: 1px solid #efefef;
                display: flex;
                align-items: center;
                .processItem{
                    display: flex;
                    align-items: center;
                    // cursor: pointer;
                    // &:hover{
                    //     .process_type{
                    //         i {
                    //             background: #1890ff;
                    //             color: #fff;
                    //             border: 1px solid #1890ff;
                    //         }
                    //         p {
                    //             color: #000;
                    //         }
                    //     }
                    // }
                }
                .process_type {
                    width: 232px;
                    height: 64px;
                    // line-height: 64px;
                    display: flex;
                    align-items: center;
                    // border-bottom: 2px solid #1890ff;
                    text-align: center;
                    justify-content: center;
                    i {
                        display: inline-block;
                        width: 24px;
                        height: 24px;
                        border: 1px solid rgba(0, 0, 0, 0.15);
                        border-radius: 50%;
                        color: rgba(0, 0, 0, 0.15);
                        line-height: 27px;
                        font-size: 14px;
                        margin-right: 8px;
                    }
                    p {
                        font-size: 16px;
                        color: rgba(0, 0, 0, 0.3);
                    }
                }
                .typeIcon {
                    color: rgba(0, 0, 0, 0.3);
                    font-size: 18px;
                }
                .process_type2 {
                    border-bottom: 3px solid #1890ff;
                    i {
                        background: #1890ff;
                        color: #fff;
                        border: 1px solid #1890ff;
                    }
                    p {
                        color: #000;
                    }
                }
            }
            .basicInformation{
                display: flex;
                padding: 25px 32px;
                border-bottom: 1px solid #ddd;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .goodsItem{
                    display: flex;
                    padding-bottom: 14px;
                    font-size: 14px;
                    .name{
                        color: rgba(0, 0, 0, 0.85);
                        min-width: 80px;
                    }
                    .content{
                        color: rgba(0, 0, 0, 0.65);
                    }
                }
            }
            .orderInformation{
                padding: 25px 32px;
                border-bottom: 1px solid #ddd;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .orderTop{
                    display: flex;
                    .orderItem{
                        padding-left: 50px;
                        i{
                            color: #1890FF;
                            padding-left: 10px;
                            cursor: pointer;
                        }
                    }
                }
                .orderBottom{
                    display: flex;
                }
                .orderItem{
                    font-size: 14px;
                    display: flex;
                    width: 20%;
                    .name{
                        color: rgba(0, 0, 0, 0.85);
                    }
                    .content{
                        color: rgba(0, 0, 0, 0.65);
                    }
                }
            }
            .printInformation{
                padding: 25px 32px;
                border-bottom: 2px dashed #000;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .printTableContent{
                    .tableHeader{
                        display: flex;
                        height: 54px;
                        background:rgba(0,0,0,.02);
                        line-height: 54px;
                        font-size: 14px;
                        color: #000000;
                        .name{
                            flex: 1;
                            padding: 0 30px;
                            min-width: 600px;
                        }
                    }
                    .tableBody{
                        display: flex;
                        align-items: center;
                        .name{
                            text-align: left;
                        }
                        .explain {
                            padding: 20px;
                        }
                        .price{
                            color: #E42424;
                        }
                        .argumentsName {
                            padding-bottom: 8px;
                            font-size: 14px;
                            span{
                                color: rgba(51, 51, 51, 0.85);
                            }
                        }
                    }
                    .orderInfo {
                        padding: 30px 20px;
                        display: flex;
                        align-items: center;
                        img {
                            display: block;
                            width: 100px;
                            height: 100px;
                            border-radius: 10px;
                            margin-right: 30px;
                        }

                        .infoContent {
                            .infoName {
                                font-size: 14px;
                                color: #000000;
                                padding-bottom: 10px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                max-width: 550px;
                            }

                            .infoOther {
                                font-size: 13px;
                                color: #999999;
                                padding-bottom: 8px;
                            }
                        }
                    }
                    .sort{
                        width: 60px;
                        text-align: center;
                        padding: 0 10px;
                    }
                    .name{
                        flex: 1;
                        padding: 0 10px;
                        min-width: 600px;
                    }
                    .explain{
                        text-align: center;
                        padding: 0 10px;
                        width: 400px;
                    }
                    .price{
                        text-align: center;
                        padding: 0 10px;
                        width: 150px;
                    }
                    .num{
                        text-align: center;
                        padding: 0 10px;
                        width: 150px;
                    }
                }
            }
            .commodityPrices{
                padding: 20px 30px 0 0;
                .priceItem{
                    display: flex;
                    justify-content: flex-end;
                    padding-bottom: 15px;
                    font-size: 14px;
                    color: #404040;
                    .content{
                        min-width: 100px;
                        text-align: right;
                    }
                    &.fontWeight{
                        font-weight: 700;
                        .content{
                            color: #FF375F;
                        }
                    }
                }
            }
            .functionButton{
                position: fixed;
                bottom: 20px;
                right: 30px;
            }
        }
    }
    .billingInformation{
        .title{
            color: rgba(0, 0, 0, 0.85);
            padding: 5px 0 10px 15px;
            border-bottom: 1px solid #ddd;
            font-weight: 700;
        }
        .billingContent{
            padding: 10px 10px 0;
            color: rgba(0, 0, 0, 0.65);
            .billingItem{
                display: flex;
                padding-bottom: 10px;
            }
        }
    }
    .electronicInvoice {
        h3 {
            padding-bottom: 15px;
            color: #000;
            font-size: 15px;
        }

        .invoiceList {
            .invoiceItem {
                border: 1px solid #ddd;
                padding: 10px 50px 10px 15px;
                border-radius: 10px;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                position: relative;

                .invoiceCheckBox {
                    padding-right: 15px;
                }

                .type {
                    font-size: 12px;
                    color: #666;
                    padding-bottom: 5px;
                }

                .name {
                    font-size: 15px;
                    color: #000;
                    padding-bottom: 5px;
                }

                .num {
                    font-size: 12px;
                    color: #333;
                }

                .edit {
                    position: absolute;
                    right: 15px;
                    top: 50%;
                    margin-top: -10px;
                    padding: 0;
                }
            }
        }

        .emailList {
            padding: 0 15px 15px;

            /deep/ .el-radio {
                margin-bottom: 15px;
                display: block;
                margin-right: 0;
            }
        }
    }
    .addressList{
        padding: 24px 15px 0;
        display: flex;
        flex-wrap: wrap;
        .addressItem{
            padding: 14px 22px;
            margin-bottom: 24px;
            margin-right: 30px;
            position: relative;
            width: 270px;
            border-radius: 8px;
            border: 2px dashed #E3E3E3;
            font-size: 14px;
            .addressBorder{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
            &.active{
                border: 2px dashed #fff;
            }
            &:nth-of-type(4n){
                margin-right: 0;
            }
            .checkBox{
                position: absolute;
                right: 22px;
                top: 14px;
            }
            .name{
                color: #000;
            }
            .tel{
                color: rgba(51, 51, 51, 0.85);
                padding: 6px 0;
            }
            .address{
                color: rgba(51, 51, 51, 0.85);
                line-height: 22px;
            }
        }
        .addItem{
            text-align: center;
            cursor: pointer;
            color: #666;
            &:hover{
                border: 2px dashed #1890FF;
            }
            .icon{
                font-size: 30px;
            }
            .addName{
                font-size: 14px;
                padding-top: 5px;
            }
        }
    }
        .evaluateDialogBox {
        .evaluateItem {
            .name {
                font-size: 14px;
                color: #000;
                padding-bottom: 20px;
                font-weight: bold;
            }

            .content {
                padding-left: 20px;
                padding-bottom: 15px;
            }

            .rateItem {
                display: flex;
                align-items: center;
                padding-bottom: 15px;

                .name {
                    padding: 0 20px 0 0;
                    font-size: 13px;
                    color: #333;
                    min-width: 100px;
                    font-weight: normal;
                }
            }

            .evaluateTag {
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-checkbox-button {
                    display: block;
                    margin-right: 20px;
                    margin-bottom: 15px;

                }

                /deep/ .el-checkbox-button__inner {
                    border: 1px solid #DCDFE6 !important;
                    border-radius: 4px;
                    padding: 8px 15px;
                    font-size: 13px;
                    box-shadow: none;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/serverOrderDetails.vue